import { Component, Input, EventEmitter, Output } from '@angular/core'
import { Paginator } from '../../models/interfaces'
import { Address } from '../../models/models'
import { ToastController } from 'ionic-angular'

@Component({
	selector: 'address-list',
	templateUrl: 'address-list.html'
})
export class AddressListComponent {
	private _addresses: Address[] = null;
	public isLoading: boolean = true;

	@Input() isEditable: boolean = false;
	@Input() isDeletable: boolean = false;
	@Input() isPriorityVisible: boolean = false;
	@Input() isTypeVisible: boolean = false;

	@Input() public pageSize: number = 10;

	@Output() refresh: EventEmitter<Address[]> = new EventEmitter<Address[]>();

	private _paginator: Paginator<Address> = null;
	@Input() public set paginator(paginator: Paginator<Address>) {
		this._paginator = paginator

		if(paginator) {
			console.debug('[AddressList.set paginator(paginator)] Specificato loader per lista indirizzi: Eseguo il primo caricamento')
			this.load(true)
		}
	}
	/**
	Può essere valorizzato direttamente o in alternativa impostando paginator
	*/
	@Input() @Output() public set addresses(addresses: Address[]) {
		this._addresses = addresses
		this.isLoading = false
	}
	public get addresses(): Address[] {
		return this._addresses
	}

	constructor(private toastCtrl: ToastController) {
	}

	/**
	Carica indirizzi, paginati o da capo
	*/
	public load(
		forceReload = false
	): Promise<void> {
		if(!this._paginator) {
			console.debug('Paginatore non pronto, posticipo il caricamento')
			return
		}

		let self = this

		let lastMessage: Address = null

		return new Promise((resolve, reject) => {
			this._paginator.next(lastMessage, self.pageSize).then((addresses: Address[]) => {
				console.debug('[AddressList.load()] Caricati nuovi indirizzi: ', addresses)

				//XXX messo qui perchè in seguito a doppio evento di refresh carica 2 volte e si accodano
				if(self._addresses === null || forceReload) {
					console.debug('[AddressList.load()] Primo caricamento o ricaricamento forzato')
					self._addresses = []//bypass isPreloading=false
				} else if(self.addresses.length > 0) {
					console.debug('[AddressList.load()] Avanzamento di pagina')
					lastMessage = self._addresses[self.addresses.length - 1]
				}


				for(let address of addresses) {
					self._addresses.push(address)
				}

				self.isLoading = false

				self.refresh.emit(self._addresses)

				resolve()
			}).catch(e => {
				console.error('Errore caricando altri indirizzi: ', e)
				self.isLoading = false

				let toast = self.toastCtrl.create({
					message: 'Errore recuperando gli indirizzi',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()

				self.refresh.emit(self._addresses)

				reject()
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/components/address-list/address-list.ts